import { uniq } from 'lodash/fp';
import { Plan } from '../../../../types/CompanyPaymentDto';
import { ReviewCycleDto, ReviewCycleTimeline } from '../../../../types/ReviewCycleDto';
import { CurrentUserDto } from '../../../../types/UserDtos';
import api from '../../../api';
import { ReviewCycleGuidedTimeline } from '../../features/Reviews/types';

export function isReviewerInCycles(user: CurrentUserDto) {
    return api.reviewCyclesV2
        .getCycles({ mainReviewerId: user.id, contributingReviewerId: user.id })
        .then(cycles => cycles.length > 0);
}

export function getCycleLimit(plan: Plan) {
    const cycleLimits: { [plan in Plan]?: number } = {
        [Plan.Launch]: 5,
    };
    return cycleLimits[plan] || null;
}

export type CyclesPerYear = Record<number, ReviewCycleDto[]>;

export async function getCyclesPerYear(): Promise<CyclesPerYear> {
    const cycles = await api.reviewCycles.list();
    return cycles.reduce<CyclesPerYear>((cyclesPerYear, cycle) => {
        const yearsOfCycle = getYearsOfCycleTimeline(cycle.timeline);
        yearsOfCycle.map(year => {
            if (!cyclesPerYear[year]) {
                cyclesPerYear[year] = [];
            }
            cyclesPerYear[year].push(cycle);
        });
        return cyclesPerYear;
    }, {});
}

/**
 * Determine the years of a cycle’s timeline that should be used for the cycle limit calculation.
 */
export function getYearsOfCycleTimeline(timeline: ReviewCycleTimeline | ReviewCycleGuidedTimeline): number[] {
    return uniq([getYear(timeline.processStarts!), getYear(timeline.signBy!)]);
}

export function getYear(date: number | Date) {
    return new Date(date).getFullYear();
}
